export const hasMatchingTypeInstallation = ({
  itemTypeInstallation,
  typeInstallation,
}: {
  itemTypeInstallation: string | null;
  typeInstallation: string | null;
}): boolean => {
  if (itemTypeInstallation == null || typeInstallation == null) return false;
  return itemTypeInstallation === typeInstallation;
};
